import type { TRelation, TVersionRestrictionVariation } from '../definitions'

/**
 * Relációs jel elkérése a levizsgálásból.
 * @param variation - Tiltóvariáció.
 */
export default function getRelation (variation: TVersionRestrictionVariation): TRelation {
  return variation.charAt(0) as TRelation
}
